export default "__VITE_ASSET__B5TRIv0C__"